module.exports = __webpack_public_path__ + "img/8.8d3a85aa.png";